import React from 'react';

import Image from '../../../../library/image/image';
import Typography from '../../../../library/typography/typography';

import { useMyAccount } from '../../../../shared/hooks/hooks';

import { PaymentType } from '../../../../shared/types/graphql-types';

import './easy-pay-options.scss';

function EasyPayOptions() {
  const { isFleetAccount, user } = useMyAccount();

  const showArChargeMessage =
    process.env.__FF_FLEET_ACCOUNT__ === 'true' &&
    isFleetAccount &&
    user?.isB2bChargeAuthorized &&
    user?.supportedPaymentType?.includes(PaymentType.ArCharge);

  if (
    process.env.__FF_AFFIRM_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_APPLE_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_GOOGLE_PAY_CHECKOUT__ !== 'true' &&
    process.env.__FF_PAYPAL_CHECKOUT__ !== 'true'
  ) {
    return null;
  }

  return (
    <aside
      styleName={`container ${showArChargeMessage ? 'container--fleet' : ''}`}
    >
      <Typography styleName="title" tag="span" weight="bold">
        Easy Pay Options
      </Typography>
      <div styleName="payment-options-container">
        {process.env.__FF_AFFIRM_PAY_CHECKOUT__ === 'true' && (
          <Image
            alt="affirm logo"
            loading="lazy"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/Affirm-Logo.svg"
            styleName="payment-logo affirm-logo"
          />
        )}
        {process.env.__FF_PAYPAL_CHECKOUT__ === 'true' && (
          <Image
            alt="paypal logo"
            loading="lazy"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/badges/paypal-logo.svg"
            styleName="payment-logo"
          />
        )}
        {process.env.__FF_APPLE_PAY_CHECKOUT__ === 'true' && (
          <Image
            alt="apple pay logo"
            loading="lazy"
            src="https://discounttire.scene7.com/is/content/discounttire/discounttire/customerservice/payments/Apple_Pay.svg"
            styleName="payment-logo"
          />
        )}
        {process.env.__FF_GOOGLE_PAY_CHECKOUT__ === 'true' && (
          <Image
            alt="google pay logo"
            loading="lazy"
            src="https://discounttire.scene7.com/is/content/discounttire/logos/badges/google-pay.svg"
            styleName="payment-logo"
          />
        )}
        {showArChargeMessage && (
          <Typography styleName="ar-charge-message">
            <span styleName="ar-charge-text">Fleet B2B Charge Account</span>
            &nbsp;is available as a payment option for your company.
          </Typography>
        )}
      </div>
    </aside>
  );
}

export default EasyPayOptions;
